import type { ReactElement } from 'react';

/**
 * RubricVersionBadge — small "v2 rubric" tag rendered alongside scan-date
 * metadata on the repo drill-down (FR-6 AC-6.3).
 *
 * Renders only when `rubricVersion === 'v2'`. Mirrors the existing v1-legacy
 * badge pattern — same size, same `.badge` styling, framework-neutral copy.
 */

interface RubricVersionBadgeProps {
  /** Rubric version stamped on the underlying ScoreItem. Undefined = legacy row. */
  rubricVersion: 'v1' | 'v2' | undefined;
}

export function RubricVersionBadge({ rubricVersion }: RubricVersionBadgeProps): ReactElement | null {
  if (rubricVersion !== 'v2') {
    return null;
  }
  return (
    <span
      className="badge badge-info"
      data-testid="rubric-version-badge"
      aria-label="Scored with version 2 rubric"
      title="This score was produced under the v2 framework-neutral rubric."
    >
      v2 rubric
    </span>
  );
}
